import { useApp } from '../app-context';
import './PoliciesList.scss';
import { TSAccordion } from './commons';

const Policy = function ({ policy }) {
    const [, dispatcher] = useApp();

    const handleClick = (e) => {
        e.preventDefault();
        dispatcher({ action: "closePage", params: { id: "main" } });
        dispatcher({ action: "showPage", params: { id: "policy", props: { policy: policy } } });
    };

    return (
        <div className={"animal" + (policy.status != 10 ? ' notActive' : '')} onClick={handleClick}>
            <div className="avatar">
                <img src={`/img/avatar-${policy.type}-new.svg`} alt="" />
            </div>
            <div className="info">
                <div className="name">{policy.name}</div>
                <div className="details">
                    <span>{policy.age || ""}</span>
                    <span>{policy.breed || "גזע לא ידוע"}</span>
                </div>
            </div>
        </div>
    )
}

const PoliciesList = function ({ policies }) {
    const [state] = useApp();

    return (
        <div className="animals-list">
            <TSAccordion title='הפוליסות שלי' forceToggle={true} uiParams={state.uiParams}>
                <div className="list">
                    {policies.map((v, k) => <Policy policy={v} key={"cha" + k} />)}
                </div>
            </TSAccordion>
        </div>
    );
};

export { PoliciesList };